import { FormattedMessage } from 'react-intl'
import { Text, TouchableOpacity, View } from 'react-native'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { media } from '../../../../style/media'

export const smallBtnSize = (fontSize, atLeastTablet) => fontSize * (atLeastTablet ? 1.9 : 1.7)
export const centerBtnSize = (fontSize, atLeastTablet) => fontSize * (atLeastTablet ? 3.8 : 2.5)
export const desktopBtnSize = (fontSize) => fontSize * 3

export const ButtonContent = styled(View)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  padding: ${(props) => `${props.theme.spacing.sm}px ${props.theme.spacing.sm * 1.5}px`};

  ${media.md`
    padding: ${(props) => `${props.theme.spacing.md}px ${props.theme.spacing.md}px`};
  `};
`

const Label = styled(Text)`
  font-size: ${(props) => props.theme.fontSizes.small}px;
  height: ${(props) => props.theme.fontSizes.larger}px;
  color: ${(props) => props.theme.colors.text};
  text-transform: uppercase;
`

const Button = ({
  as: Component = TouchableOpacity,
  title,
  intlMessage,
  intlMsg = intlMessage,
  fontStyle,
  disabled,
  style,
  children,
  ...props
}) => (
  <Component {...props}>
    <ButtonContent style={style} disabled={disabled}>
      {children}

      {(title || intlMsg) && (
        <Label numberOfLines={1} style={fontStyle}>
          {title || <FormattedMessage {...intlMsg} />}
        </Label>
      )}
    </ButtonContent>
  </Component>
)

Button.propTypes = {
  title: PropTypes.string,
  intlMessage: PropTypes.object,
  onPress: PropTypes.func,
  /** Applied to the button text (only applies when title is provided) */
  fontStyle: PropTypes.object,
  /** Alternative to title to provide button with icons etc. */
  children: PropTypes.any,
}

export default Button

Button.smallBtnSize = smallBtnSize
